var _path, _path2, _path3, _path4, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStopwatch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 53.9219V35.3281",
    stroke: "#2DB49E",
    strokeWidth: 2.39597,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 21.252V17.5332M30.6797 31.4785L27.8906 28.6895",
    stroke: "#2DB49E",
    strokeWidth: 3.19463,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 70.6562C63.6076 70.6562 66.9375 67.3264 66.9375 63.2188C66.9375 59.1111 63.6076 55.7812 59.5 55.7812C55.3924 55.7812 52.0625 59.1111 52.0625 63.2188C52.0625 67.3264 55.3924 70.6562 59.5 70.6562Z",
    stroke: "#2DB49E",
    strokeWidth: 2.39597,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5 22.3125C51.4095 22.3125 43.5007 24.7116 36.7737 29.2064C30.0467 33.7013 24.8037 40.09 21.7076 47.5646C18.6115 55.0392 17.8014 63.2641 19.3798 71.1992C20.9581 79.1342 24.8541 86.423 30.5749 92.1438C36.2958 97.8647 43.5846 101.761 51.5196 103.339C59.4546 104.917 67.6795 104.107 75.1542 101.011C82.6288 97.9151 89.0175 92.672 93.5123 85.945C98.0072 79.218 100.406 71.3092 100.406 63.2188C100.406 52.3697 96.0965 41.9651 88.4251 34.2937C80.7537 26.6223 70.349 22.3125 59.5 22.3125Z",
    stroke: "#2DB49E",
    strokeWidth: 2.39597,
    strokeMiterlimit: 10
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 53.112,
    y1: 10.782,
    x2: 65.8906,
    y2: 10.782,
    stroke: "#2DB49E",
    strokeWidth: 2.39597,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopwatch);
export default __webpack_public_path__ + "static/media/stopwatch.f0353907a932eb68635233f9e898d930.svg";
export { ForwardRef as ReactComponent };